import React from 'react';
import { IconHighlightL } from '../../../../icons';
import { Tooltip } from '../../../../components';
import classNames from 'classnames';
import css from './PrefilledValueTooltip.css';

export const PrefilledValueTooltip = ({ rootClassName, parentContainerRef }) => {
    return (
        <Tooltip
            rootClassName={classNames(css.tooltipWrapper, rootClassName)}
            parentContainerRef={parentContainerRef}
            targetClassName={css.targetClassName}
            tooltipClassName={css.tooltipClassName}
            padding={0}
            content={
                <>
                    <p>Für dich vorausgewählt</p>
                    <p>
                        Wir haben diese Auswahl anhand deiner bisherigen Angaben für dich
                        vorausgewählt. Du kannst sie jederzeit ändern.
                    </p>
                </>
            }
        >
            <IconHighlightL />
        </Tooltip>
    );
};
